module.exports = "/img/_/_/_/assets/images/creeper/battle/common//43.jpg?750f0f6d75965e36f6b0446da2f419f5";